/* eslint camelcase: 0 */
import update from 'immutability-helper';
import Immutable from 'immutable';
import _, { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import Bundles from '../../../api/api-bundles';
import { Messages } from '../../../api/api-messages';
import { ErrorPage } from '../app-error-page/error-page';
import { fetchEnvWeb } from '../app-main/actions/env';
import { fetchMessageCount } from '../app-main/actions/nav';
import { NotificationBanner } from '../elements-banner/notification-banner';
import { BookingSummary } from '../elements-summaries/booking-summary/BookingSummary';
import { BookingStatus, GetStatus } from './booking-status';
import { InboxHeader } from './InboxHeader';
import { MessageInbox } from './inbox/message-inbox';

const MessageDetails = ({
  profile,
  details,
  name,
  bundleUpdateRequest,
  reviewCb,
  accessToken,
  iosWebView,
  updatedDetails,
  guestCanUpdate,
  hostCanUpdate,
  hasNoContracts,
  contractData = [],
  pendingContracts = [],
  canInstantBook,
  cancelUpdateDetails,
  renderReviewOfferDetails,
  dispatch,
  iosConcierge,
  inviteCreated,
  intl
}) => {
  const settings = {
    responsiveView: false,
    iosWebView
  };

  if (!iosWebView) {
    settings.forwardBtn = null;
    settings.backBtn = {
      title: intl.formatMessage({
        id: 'inbox.message_details.messages',
        defaultMessage: 'Messages'
      }),
      to: { pathname: `/inbox/${details.booking_id}` }
    };
  }

  return (
    <div className='message-main-mobile'>
      <BookingStatus
        details={details}
        name={name}
        user={profile}
        bundleUpdateRequest={bundleUpdateRequest}
        reviewCb={reviewCb}
        iosWebView={!!iosWebView}
        guestCanUpdate={guestCanUpdate}
        updatedDetails={updatedDetails}
        canInstantBook={canInstantBook}
        hostCanUpdate={hostCanUpdate}
        hasNoContracts={hasNoContracts}
        cancelUpdateDetails={cancelUpdateDetails}
        accessToken={accessToken}
        dispatch={dispatch}
        contractData={contractData}
        pendingContracts={pendingContracts}
        iosConcierge={iosConcierge}
        inviteCreated={inviteCreated}
      >
        <InboxHeader {...settings} isMessageDetailsPage={true} />
      </BookingStatus>
      <div
        className='ps-container-lg-margin'
        data-testing-id='summary-container'
      >
        <div className='ps-row'>
          <div className='col-xs-12'>
            <BookingSummary
              booking={details}
              currentContracts={contractData}
              pendingContracts={pendingContracts}
              profile={profile}
              intl={intl}
              iosWebViewConfig={{
                isWebView: true,
                renderReviewOfferDetails
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const BannerMessage = () => {
  return (
    <div className='flex middle text-white'>
      <div>
        <i className='ico icon-yes' />
      </div>
      <div className='margin-md-left'>
        <FormattedMessage
          id='inbox.banner_message.request_sent'
          defaultMessage='Services request sent'
        />
      </div>
    </div>
  );
};

class MessageMain extends React.Component {
  constructor (props, context) {
    super(props, context);
    this.state = {
      thread: null,
      details: null,
      responsiveness: null,
      fullMessage: false,
      submitted: false,
      msgError: null,
      isError: false,
      updatedDetails: null,
      cancelUpdateDetails: {},
      isSendMessageButtonDisabled: false
    };
    this.getFullMessage = this.getFullMessage.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.sendMessageCb = this.sendMessageCb.bind(this);
    this.getBookingMessageBundle = this.getBookingMessageBundle.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.reviewCb = this.reviewCb.bind(this);
    this.reloadPage = this.reloadPage.bind(this);
    this.renderBanner = this.renderBanner.bind(this);
    this.renderOTBanner = this.renderOTBanner.bind(this);
    this.generateMessageMetadata = this.generateMessageMetadata.bind(this);
  }

  componentWillMount () {
    const { id } = this.props.params;
    if (!id || 'undefined' === id) {
      window.location.href = '/inbox';
      return;
    }

    this.getBookingMessageBundle();
  }

  componentDidMount () {
    const { previousLocation, services, location } = this.props;

    if (previousLocation.pathname) {
      // if previousLocation is 'add-services' and userRequestedServices, then show banner
      const cameFromAddServices = 'add-services' === previousLocation.pathname.slice(1).split('/')[0];

      if (cameFromAddServices && services.requestedServices) {
        this.renderBanner();
      }

      if ('overtimeSuccess' === location.state) {
        this.renderOTBanner();
      }
    }
  }

  componentDidUpdate () {
    const { details } = this.state;

    if (details) {
      const name = 'GUEST' === details.view_as ? details.host.name : details.guest.name;
      const firstName = name ? name.first : '';
      const status = GetStatus({
        name: firstName,
        details,
        intl: this.props.intl
      });
      document.title = status.title
        ? this.props.intl.formatMessage({ ...status.title }, status.titleData)
        : this.props.intl.formatMessage({
          id: 'inbox.message_main.title',
          defaultMessage: 'Peerspace'
        });
    }
  }

  getBookingMessageBundle (callback) {
    const accessToken = this.getAccessToken();
    const path = `bookings-inbox/${this.props.params.id}`;
    const { dispatch, profile } = this.props;

    // get booking obj
    Bundles.read(path, accessToken, (response) => {
      if (response.error || 400 < response.statusCode) {
        return this.setState({ isError: true });
      }

      const updatedDetails = _.get(response, 'update_details.new_values');

      if (updatedDetails) {
        // these properties are one level above the rest of the details data
        updatedDetails.guest_payment_processing_fee_percent_formatted = _.get(
          response,
          'update_details.guest_payment_processing_fee_percent_formatted'
        );
        updatedDetails.host_payout_processing_fee_percent_formatted = _.get(
          response,
          'update_details.host_payout_processing_fee_percent_formatted'
        );
        updatedDetails.guest_payment_amount_difference = _.get(
          response,
          'update_details.guest_payment_amount_difference'
        );
        updatedDetails.host_payout_amount_difference = _.get(
          response,
          'update_details.host_payout_amount_difference'
        );
        updatedDetails.expires_in = _.get(
          response,
          'update_details.expires_in'
        );
      }
      this.setState({
        details: response.details,
        updatedDetails: _.get(response, 'update_details.new_values'),
        thread: response.thread,
        responsiveness: response.host_responsiveness,
        guestCanUpdate: response.can_guest_update,
        canInstantBook: response.can_instant_book,
        hostCanUpdate: response.can_host_update,
        shouldShowInviteModal: response.should_show_invite_modal,
        isError: false,
        cancelUpdateDetails: _.get(response, 'cancel_update_details', {}),
        hasNoContracts: response.has_no_contracts,
        contractData: response.contracts,
        pendingContracts: response.pending_contracts
      });

      const messages = response.thread ? response.thread.msgs : [];
      const unreadMessages = _.filter(messages, (m) => {
        return !m.is_read && profile.SSOid === m.to.sso_id;
      });

      dispatch(fetchEnvWeb(null, (envResponse) => {
        const threadStreamChannelId = get(response, 'thread.stream_channel_id', '');
        const streamChannelId = get(response, 'details.stream_channel_id') || threadStreamChannelId;
        const shouldReadMessages = !envResponse.stream_enabled || !streamChannelId;
        if (shouldReadMessages) {
          // mark unread messages in thread as read
          unreadMessages.forEach((msg) => {
            const updatePath = `id=${msg.msg_id}&is_read=true`;

            Messages.update(updatePath, accessToken, () => {
              return null;
            });
          });
        }
      }));

      if (callback) {
        callback();
      }

      return dispatch(fetchMessageCount(accessToken, profile));
    });
  }

  getFullMessage () {
    const accessToken = this.getAccessToken();
    const { fullMessage } = this.state;
    const path = !fullMessage
      ? `bookings-inbox/${this.props.params.id}/thread`
      : `bookings-inbox/${this.props.params.id}`;
    this.setState({ submitted: true });
    if (accessToken) {
      // get booking obj
      Bundles.read(path, accessToken, (response) => {
        if (response.error || 400 < response.statusCode) {
          return this.setState({ isError: true });
        }
        this.setState({
          thread: response.thread,
          fullMessage: !fullMessage,
          submitted: false,
          isError: false
        });
      });
    }
  }

  getAccessToken () {
    return this.props.auth.accessToken;
  }

  reloadPage () {
    window.location.reload();
  }

  reviewCb () {
    const newDetails = update(this.state.details, {
      review: { complete: { $set: true } }
    });
    this.setState({
      details: newDetails
    });
    this.closeModal();
  }

  closeModal () {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
    $('#modal-container').modal('hide');
  }

  sendMessage (e, callback) {
    this.setState(
      {
        isSendMessageButtonDisabled: true
      },
      () => {
        const body = $('#message').val();
        const accessToken = this.getAccessToken();
        const payload = this.generateMessageMetadata(body);
        if (accessToken) {
          Messages.create(payload, accessToken, callback);
        }
      }
    );
  }

  sendMessageCb (response) {
    if (response.error || response.err || 400 < response.statusCode) {
      // Something went wrong when creating the message
      return this.setState({
        msgError: this.props.intl.formatMessage({
          id: 'inbox.message_main.something_wrong',
          defaultMessage: 'Something went wrong. Please try again.'
        })
      });
    }
    const { body, date_created, from, is_read, subject } = response.msg;
    const newMsg = {
      body,
      created: date_created,
      from: {
        avatar_id: from.avatar_id
      },
      is_read,
      msg_id: response.id,
      subject
    };
    const thread = Immutable.fromJS(this.state.thread);
    const newThread = thread.update('msgs', (msgs) => {
      return msgs.push(newMsg);
    });
    $('#message').val('');
    this.setState({
      thread: newThread.toJS(),
      msgError: null,
      isSendMessageButtonDisabled: false
    });
  }

  renderBanner () {
    ReactDOM.render(
      <NotificationBanner showClose timing={4.6} message={BannerMessage()} />,
      document.getElementById('banner-container')
    );
  }

  renderOTBanner () {
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <NotificationBanner
          showClose
          timing={4.6}
          message={
            <div className='overtime-banner'>
              <ul className='text-center list-inline'>
                <li className='text-large heavy'>
                  <i className='ico ico-md icon-confirmed-check' />
                </li>
                <li>
                  <FormattedMessage
                    id='inbox.message_main.overtime'
                    defaultMessage='Your overtime charges have been submitted and sent to your guest for review.'
                  />
                </li>
              </ul>
            </div>
          }
        />
      </SharedIntlProviderHOC>,
      document.getElementById('banner-container')
    );
  }

  generateMessageMetadata (text) {
    const { booking_id, listing, host, guest, metro, obj_state } = this.state.details;
    const { msgs, thread_id } = this.state.thread;
    const { sso_id } = host || guest;

    return {
      mtype: 'msg',
      metro,
      is_read: false,
      is_archived: false,
      thread_id,
      body: text,
      subject: msgs[0] ? msgs[0].subject : null,
      from: {
        ssoid: this.props.profile.SSOid
      },
      to: {
        ssoid: sso_id
      },
      listing_id: listing.listing_id,
      bkg: {
        id: booking_id,
        state: obj_state,
        guest: guest ? sso_id : this.props.profile.SSOid,
        host: host ? sso_id : this.props.profile.SSOid
      },
      prefs: ['push']
    };
  }

  render () {
    const {
      details,
      thread,
      submitted,
      responsiveness = {},
      isError,
      guestCanUpdate,
      canInstantBook,
      updatedDetails,
      hostCanUpdate,
      cancelUpdateDetails,
      shouldShowInviteModal,
      hasNoContracts,
      contractData,
      pendingContracts
    } = this.state;

    if (isError) {
      return (
        <ErrorPage
          button={this.props.intl.formatMessage({
            id: 'inbox.message_main.error_okay',
            defaultMessage: 'Okay'
          })}
          linkFn={this.reloadPage}
          link=''
        />
      );
    }

    if (details && thread) {
      const name = 'GUEST' === details.view_as ? details.host.name : details.guest.name;
      const firstName = name ? name.first : '';
      const inviteCreated = !!get(details, 'public_fields.guest_title', '');
      return (
        <SharedIntlProviderHOC>
          {'details' === this.props.location.query.page ? (
            <MessageDetails
              details={details}
              profile={this.props.profile}
              name={firstName}
              bundleUpdateRequest={this.getBookingMessageBundle}
              reviewCb={this.reviewCb}
              updatedDetails={updatedDetails}
              guestCanUpdate={guestCanUpdate}
              hostCanUpdate={hostCanUpdate}
              hasNoContracts={hasNoContracts}
              contractData={contractData}
              pendingContracts={pendingContracts}
              canInstantBook={canInstantBook}
              cancelUpdateDetails={cancelUpdateDetails}
              accessToken={this.props.accessToken}
              dispatch={this.props.dispatch}
              intl={this.props.intl}
              inviteCreated={inviteCreated}
            />
          ) : (
            <div>
              <MessageInbox
                updatedDetails={updatedDetails}
                appProps={this.props}
                details={details}
                thread={thread}
                name={firstName}
                responsiveness={responsiveness}
                getFullMessage={this.getFullMessage}
                spinner={submitted}
                actionFn={this.sendMessage}
                actionCb={this.sendMessageCb}
                msgError={this.state.msgError}
                bundleUpdateRequest={this.getBookingMessageBundle}
                reviewCb={this.reviewCb}
                context={this.context}
                guestCanUpdate={guestCanUpdate}
                hostCanUpdate={hostCanUpdate}
                hasNoContracts={hasNoContracts}
                contractData={contractData}
                pendingContracts={pendingContracts}
                canInstantBook={canInstantBook}
                shouldShowInviteModal={shouldShowInviteModal}
                cancelUpdateDetails={cancelUpdateDetails}
                accessToken={this.props.accessToken}
                dispatch={this.props.dispatch}
                intl={this.props.intl}
                profile={this.props.profile}
                env={this.props.env}
                inviteCreated={inviteCreated}
                generateMessageMetadata={this.generateMessageMetadata}
              />
            </div>
          )}
        </SharedIntlProviderHOC>
      );
    }
    return <div />;
  }
}

MessageMain.contextTypes = {
  router: PropTypes.object
};

MessageMain.propTypes = {
  location: PropTypes.object,
  params: PropTypes.object,
  profile: PropTypes.object,
  auth: PropTypes.object,
  previousLocation: PropTypes.object,
  services: PropTypes.object,
  dispatch: PropTypes.func,
  accessToken: PropTypes.string,
  intl: intlShape
};

MessageDetails.propTypes = {
  profile: PropTypes.object,
  details: PropTypes.object,
  name: PropTypes.string,
  bundleUpdateRequest: PropTypes.func,
  reviewCb: PropTypes.func,
  iosWebView: PropTypes.bool,
  cancelUpdateDetails: PropTypes.object,
  intl: intlShape
};

exports.MessageMain = injectIntl(MessageMain);
exports.MessageDetails = injectIntl(MessageDetails);
